﻿import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_franquia/franquia-estoque-transferencia";

export const Route = createFileRoute("/_authenticated/franquia-estoque-transferencia")({
  head: () => ({
    meta: [
      { title: "Transferência entre estoques — Milky Moo Palmares" },
      { name: "description", content: "Registre transferências de insumos entre os estoques." },
      { property: "og:title", content: "Transferência entre estoques — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Registre transferências de insumos entre os estoques.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
